import { DeviceModel, DeviceSetup } from '@iws/pos-devices'

import { httpRequest } from '@/clients/http'

/** The device catalog (System Admin) and this terminal's device setup backup (POS.md §18.9). */
export const DeviceCatalogModel = {
  getModels: () => httpRequest<{ result: DeviceModel[] }>({ method: 'get', url: '/api/backoffice/pos-offline/device-models' }),

  saveSetup: (terminalId: string, setup: DeviceSetup) =>
    httpRequest<{ result: DeviceSetup }>({ method: 'put', url: `/api/backoffice/terminal/${terminalId}/device-setup`, body: setup }),
}
